import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCreateGuestMutation } from '../services/majesticResortsApi';
import { allowStateResidenceByCountry, allowZipCodeByCountry, clearCustomFormatter, getCountryByCode, getDocumentTypeToApi, getSexByCode, getStateResidenByCode, getStringDate, replaceDataImage } from '../utils';
import { useSendDocumentsMutation, useSendMailMutation } from '../services/ocrApi';

function useCreateGuestAndAws() {
  const { hotel, language } = useSelector((state) => state.checking);
  const { dataResidence, selectedGuest, guestHolder } = useSelector((state) => state.guests);
  const { documentType, nationality } = useSelector((state) => state.ocr);
  const { booking } = useSelector((state) => state.booking);

  const [
    createGuest,
    {
      isError: isErrorCreate,
      error: errorCreate,
      isSuccess: isSuccessCreate,
    },
  ] = useCreateGuestMutation();
  const [
    sendDocuments,
    {
      isError: isErrorSendDocuments,
      error: errorSendDocuments,
      isSuccess: isSuccessSendDocuments,
    },
  ] = useSendDocumentsMutation();
  const [
    sendMail,
    {
      isError: isErrorSendMail,
      error: errorSendMail,
      isSuccess: isSuccessSendMail,
    },
  ] = useSendMailMutation();

  const showAntiDrugs = () => (/*dataResidence.country.iso2 === 'MX' &&*/ (hotel === 'M4' || hotel === 'M5'));

  const getDataHolderByResidence = () => {
    let {
      email,
      phoneNumber,
      country,
      state,
      zipCode,
    } = dataResidence;

    if (['2', '3'].includes(selectedGuest.TipoPersona)) {
      email = guestHolder.DatosComunicacion.EMail;  // noemail@noemail.com.
      phoneNumber = guestHolder.DatosComunicacion.Telefono;
      country = getCountryByCode(guestHolder.DatosComunicacion.Pais);
      state = getStateResidenByCode(guestHolder.DatosComunicacion.Provincia);
      zipCode = guestHolder.DatosComunicacion.CodigoPostal;
    }

    return {
      email,
      phoneNumber,
      country,
      state,
      zipCode,
    };
  };

  const handlerCreateGuest = async (dataGuest) => {
    const {
      email,
      phoneNumber,
      country,
      state,
      zipCode,
    } = getDataHolderByResidence();

    let newGuest = {
      ...dataGuest,
      DatosComunicacion: {
        ...dataGuest.DatosComunicacion,
        // Telefono: dataResidence.phoneNumber,
        Telefono: phoneNumber,
        // Telefono: `+${dataResidence.keyTelephone} ${dataResidence.phoneNumber}`,
        // EMail: dataResidence.email,
        EMail: email,
        // Pais: dataResidence.country.iso2,
        Pais: country.iso2,
      },
      // Email: dataResidence.email,
      Email: email,
      TipoDocumento: getDocumentTypeToApi(documentType),
      PaisNacimiento: nationality.iso2,
    };

    // Para residentes CAN o USA
    if (allowStateResidenceByCountry(country)) {
      newGuest.DatosComunicacion.Provincia = state.iso2State;
    }

    // Para residentes MEX
    if (allowZipCodeByCountry(country)) {
      newGuest.DatosComunicacion.CodigoPostal = zipCode;
    }

    // if (showAntiDrugs() && dataGuest.TipoPersona !== '3') {
    //   setDocumentTypeList([...documentTypeList, 'turismo']);
    //   // documentTypeList.push('turismo');
    // }

    newGuest = clearCustomFormatter(newGuest);

    const data = { d: newGuest };

    console.log(data)

    await createGuest(data).unwrap();
  };

  const handlerSendDocument = async (OCRData, dataHotel, dataGuest, sign = '') => {
    const documentTypeList = [
      'cardex',
      'privacy',
    ];
    const {
      email,
      phoneNumber,
      country,
      state,
    } = getDataHolderByResidence();

    const dataSex = getSexByCode(OCRData.gender);

    if (['2', '3'].includes(selectedGuest.TipoPersona)) {
      documentTypeList.pop();
    }

    // Aplica para adulto
    if (showAntiDrugs() && selectedGuest.TipoPersona === '1') {
      documentTypeList.push('turismo');
    }

    const data = {
      documentTypeList,
      bookingDetails: {
        // email: dataResidence.email,
        email,
        reservationNumber: booking?.NumReserva,
        language: `${language.toLowerCase()}`,
        documentNumber: OCRData.documentNumber,
        dateArrive: booking.FechaEntrada,
        dateDeparture: booking.FechaSalida,
        hotel: booking.HotelFactura,
        hotelName: `${dataHotel.HotelName} ${dataHotel.HotelLocation}`,
        adults: booking.AD?.toString() || '',
        juniors: booking.JR?.toString() || '',
        childs: booking.NI?.toString() || '',
      },
      guestDetails: {
        firstName: dataGuest.Nombre_Pila,
        lastName: dataGuest.Nombre,
        typeOfDocument: documentType,
        issuingCountry: nationality[`name${language.toUpperCase()}`],
        issueDate: dataGuest.FechaExpedicion,
        expirationDate: dataGuest.FechaCaducidad,
        birthDate: dataGuest.FechaNacimiento,
        gender: dataSex[`Name${language.toUpperCase()}`],
        phone: phoneNumber,
        countryOfResidence: country?.[`name${language.toUpperCase()}`],
        region: state?.[`name${language.toUpperCase()}`],
        purposeOfStay: booking.MotivoViaje,
      },
      firmaBase64: replaceDataImage(sign),
    };
    // console.log(data);

    await sendDocuments(data).unwrap();
  };

  const handlerSendMail = async (OCRData, dataHotel, dataGuest) => {
    const {
      email,
    } = getDataHolderByResidence();

    const data = {
      mail: email,
      nameGuest: `${dataGuest.Nombre_Pila} ${dataGuest.Nombre}`,
      hotel: booking.HotelFactura,
      hotelName: `${dataHotel.HotelName} ${dataHotel.HotelLocation}`,
      dateArrive: getStringDate(booking.FechaEntrada),
      reservationNumber: booking?.NumReserva,
      documentNumber: OCRData.documentNumber,
      language: `${language.toLowerCase()}`,
    };

    // console.log(data);

    await sendMail(data).unwrap();
  };

  return {
    handlerCreateGuest,
    handlerSendDocument,
    handlerSendMail,
    isErrorCreate,
    errorCreate,
    isErrorSendDocuments,
    errorSendDocuments,
    isErrorSendMail,
    errorSendMail,
    isSuccessCreate,
    isSuccessSendDocuments,
    isSuccessSendMail,
  };
}

export default useCreateGuestAndAws;
